import React from 'react';

import waicon from "../assets/images/waicon.png"
import fbicon from "../assets/images/fbicon.png"
import skypeicon from "../assets/images/skyepeicon.png"


const Social = () => {
    return (
        <ul id="social">
            <li style={{ backgroundColor: "rgb(27,215,65)" }}>
                <a target="blank" href="https://wa.me/+923454459673?text=">
                    <img src={waicon} />
                </a>
            </li>
            <li style={{ backgroundColor: "rgb(59,89,152)"}}>
                <a target="blank" href="https://www.facebook.com/hassan.academy01">
                    <img src={fbicon} />
                </a>
            </li>
            <li style={{ backgroundColor: "rgb(21,172,229)", borderRadius: "0  0% 0 0" }}>
                <a target="blank" href="https://join.skype.com/invite/VuPf0EShvKKB">
                    <img src={skypeicon} />
                </a>
            </li>

        </ul>
    );
};

export default Social;